import { css } from '@inter-ikea-kompis/web-component';
const MIN_ICON_SIZE = 24;
export default class RepairabilityIndexStyle {
    static getStyle() {
        return css `
			:host {
				display: block;
			}
			img {
				height: 2em;
			}
			.imageContainer {
				cursor: pointer;
				display: flex;
				justify-content: center;
				align-items: center;
				min-height: ${MIN_ICON_SIZE / 16}rem;
				min-width: ${MIN_ICON_SIZE / 16}rem;
				outline: none;
			}
		`;
    }
}
//# sourceMappingURL=RepairabilityIndexStyle.js.map